
import { Link } from 'react-router-dom';

export default function Footer() {
  const footerLinks = {
    'DSCR Loans': [
      { label: 'What is a DSCR Loan?', path: '/dscr-loans' },
      { label: 'DSCR Requirements', path: '/dscr-loan-requirements' },
      { label: 'DSCR Loan Rates', path: '/dscr-loan-rates' },
      { label: 'Types of DSCR Loans', path: '/types-of-dscr-loans' },
      { label: 'DSCR Loan Benefits', path: '/dscr-loan-benefits' },
    ],
    'Resources': [
      { label: 'Best DSCR Lenders', path: '/best-dscr-lenders' },
      { label: 'DSCR Calculator', path: '/#calculator' },
    ],
    'Company': [
      { label: 'Apply Now', path: '/apply' },
      { label: 'About Us', path: '/about' },
    ],
    'Contact': [
      { label: 'Phone: 347-586-0671', path: 'tel:3475860671', external: true },
      { label: 'Email: info@dscrloans.com', path: 'mailto:info@dscrloans.com', external: true },
      { label: 'Hours: Mon-Fri 9AM-6PM EST', path: '#', external: false },
    ],
  };

  return (
    <footer className="bg-gradient-to-br from-slate-800 via-slate-700 to-gray-800 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        {/* Main Footer Content */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-8 mb-12">
          {/* Brand Section */}
          <div className="lg:col-span-1">
            <Link to="/" className="flex items-center space-x-3 mb-6 group">
              <div className="flex items-center justify-center w-12 h-12 bg-gradient-to-br from-yellow-500 to-yellow-600 rounded-xl shadow-lg group-hover:shadow-yellow-400/50 transition-all">
                <i className="ri-home-smile-line text-2xl text-slate-900"></i>
              </div>
              <div>
                <div className="text-xl font-bold">DSCR Loans</div>
                <div className="text-sm text-slate-300">Investment Property Financing</div>
              </div>
            </Link>
            <p className="text-slate-300 text-sm leading-relaxed mb-6">
              Specializing in DSCR loans for real estate investors. No income verification required.
            </p>
            <div className="flex space-x-4">
              <a
                href="#"
                className="flex items-center justify-center w-10 h-10 bg-slate-700 hover:bg-yellow-500 text-white hover:text-slate-900 rounded-lg transition-all"
              >
                <i className="ri-facebook-fill text-xl"></i>
              </a>
              <a
                href="#"
                className="flex items-center justify-center w-10 h-10 bg-slate-700 hover:bg-yellow-500 text-white hover:text-slate-900 rounded-lg transition-all"
              >
                <i className="ri-twitter-x-line text-xl"></i>
              </a>
              <a
                href="#"
                className="flex items-center justify-center w-10 h-10 bg-slate-700 hover:bg-yellow-500 text-white hover:text-slate-900 rounded-lg transition-all"
              >
                <i className="ri-linkedin-fill text-xl"></i>
              </a>
            </div>
          </div>

          {/* Footer Links */}
          {Object.entries(footerLinks).map(([category, links]) => (
            <div key={category}>
              <h3 className="text-lg font-bold mb-4 text-yellow-400">{category}</h3>
              <ul className="space-y-3">
                {links.map((link) => (
                  <li key={link.label}>
                    {link.external ? (
                      <a
                        href={link.path}
                        className="text-slate-300 hover:text-yellow-400 transition-colors flex items-center group text-sm"
                      >
                        <i className="ri-arrow-right-s-line text-yellow-500 opacity-0 group-hover:opacity-100 -ml-5 group-hover:ml-0 transition-all"></i>
                        <span className="group-hover:translate-x-1 transition-transform">{link.label}</span>
                      </a>
                    ) : (
                      <Link
                        to={link.path}
                        className="text-slate-300 hover:text-yellow-400 transition-colors flex items-center group text-sm"
                      >
                        <i className="ri-arrow-right-s-line text-yellow-500 opacity-0 group-hover:opacity-100 -ml-5 group-hover:ml-0 transition-all"></i>
                        <span className="group-hover:translate-x-1 transition-transform">{link.label}</span>
                      </Link>
                    )}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        {/* Bottom Bar */}
        <div className="pt-8 border-t border-slate-600">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <div className="text-slate-400 text-sm">
              © {new Date().getFullYear()} DSCR Loans. All rights reserved.
            </div>
            <div className="flex items-center space-x-6 text-sm">
              <Link to="#" className="text-slate-400 hover:text-yellow-400 transition-colors">
                Privacy Policy
              </Link>
              <Link to="#" className="text-slate-400 hover:text-yellow-400 transition-colors">
                Terms of Service
              </Link>
              <a 
                href="https://readdy.ai/?ref=logo" 
                target="_blank" 
                rel="noopener noreferrer"
                className="text-slate-400 hover:text-yellow-400 transition-colors"
              >
                Website Builder
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
